import { Box, styled } from '@mui/material';

export const StrengthSegment = styled(Box)<{ color: string }>(({ color }) => ({
  width: '30px',
  height: '3px',
  borderRadius: '2px',
  backgroundColor: color,
}));

export const PasswordStrengthContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '8px',
  gap: '5px',
  padding: '5px 10px',
});

export const PasswordStrengthSegmentsContainer = styled(Box)({
  display: 'flex',
  gap: '10px',
});

export const PasswordsMatchTextContainer = styled(Box)({
  display: 'flex',
  gap: '5px',
  marginTop: '8px',
  alignItems: 'center',
});
